const Constants = {
	INVOICE_STATUS: {
		NEW: 1,
		PAYED: 2
	}

};

export default Constants;




// WEBPACK FOOTER //
// ./src/constants.js